import { Box, Dialog, Theme, Typography } from "@mui/material";
import EditRiskProfile from "./EditRiskProfile";

export default function RiskScoreModal(props: any): JSX.Element {
    const { open, close } = props;
    return (
        <Dialog
            onClose={close}
            open={open}
            maxWidth='lg'
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '25px',
                    backgroundColor: theme.palette.common.white,
                    padding: "35px",
                    width: "1063px",
                },
            })}
        >
            <Box
                sx={{
                    paddingRight: "15px",
                }}
            >
                <Box
                    sx={(theme: Theme) => ({
                        paddingBottom: "15px",
                        borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`
                    })}
                >
                    <Typography
                        variant="h1"
                        sx={(theme: Theme) => ({
                            lineHeight: "32.5px",
                            color: theme.palette.text.primary
                        })}
                    >
                        Edit Risk Profile
                    </Typography>
                </Box>

                <Box sx={{ mt: 5, paddingX: "15px" }}>
                    <EditRiskProfile onClose={close} />
                </Box>
            </Box>
        </Dialog>
    )
}